import { ColumnDef } from '@tanstack/react-table';
import dayjs from 'dayjs';
import React from 'react';
import { dateFormat } from '../../../../../../../../../contstant';
import { StatusBadge } from '../../../../../../../../../components/Common/StatusBadge';
import { StatusesType } from '../../../../../../../../types';
import { Button } from '../../../../../../../../../components/Common/UI/Button';
import Icons from '../../../../../../../../../components/Common/Icons/Icons';

export enum EnumDocumentTypes {
  'statement' = 'Statement',
  'eTax' = 'eTax',
  'notices' = 'Notices',
}

export interface BatchDownloadRes {
  id: string;
  submittedDate: string;
  from: string;
  to: string;
  accounts: string;
  documentType: EnumDocumentTypes;
  status: StatusesType;
  type: string;
  expiration: string;
}

export const batchDownloadCol: ColumnDef<BatchDownloadRes>[] = [
  {
    accessorKey: 'submittedDate',
    header: 'Submitted Date',
    enableSorting: true,
    cell: ({ row }) => dayjs(row.getValue('submittedDate')).format(dateFormat),
  },
  {
    accessorKey: 'from',
    header: 'From',
    enableSorting: true,
    cell: ({ row }) => dayjs(row.getValue('from')).format(dateFormat),
  },
  {
    accessorKey: 'to',
    header: 'To',
    enableSorting: true,
    cell: ({ row }) => dayjs(row.getValue('to')).format(dateFormat),
  },
  {
    accessorKey: 'accounts',
    header: 'Accounts',
    enableSorting: true,
  },
  {
    accessorKey: 'documentType',
    header: 'Document Type',
    enableSorting: true,
  },
  {
    accessorKey: 'status',
    enableSorting: true,
    header: 'Status',
    cell: ({ row }) => <StatusBadge status={row.getValue('status')} />,
    size: 128,
  },
  {
    accessorKey: 'type',
    header: 'Type',
    enableSorting: true,
  },
  {
    accessorKey: 'expiration',
    header: 'Expiration',
    enableSorting: true,
  },
  {
    accessorKey: 'actions',
    header: 'Action',
    enableSorting: false,
    cell: () => (
      <Button variant="ghost" className="p-0 h-auto">
        <Icons.EditNew />
      </Button>
    ),
  },
];
